/* ==========================================================
   NURÉVE — EU-Gewährleistungslabel
   1) Vergrößerte Ansicht des Labels (Klick auf das Label oder den Textlink)
   2) Label in den Warenkorb-Drawer setzen (unter die Artikel, vor „Zur Kasse“)
   3) Textlink unter den Kaufbutton der Produktseite setzen
   4) Label im Drawer erst laden, wenn es sichtbar wird

   Die Grafik wird nur angezeigt, nie verändert.
   Die Vorlagen kommen aus sections/nrv-sky-boot.liquid.
   ========================================================== */
(function () {
  if (window.__nrvGw) return;
  window.__nrvGw = true;

  var INFO_URL = 'https://europa.eu/youreurope/garantien';
  var dlg = null;
  var dlgImg = null;
  var lastTrigger = null;

  /* ---------- 1) Vergrößerte Ansicht ---------- */
  function build() {
    dlg = document.createElement('dialog');
    dlg.className = 'nrv-gw nrv-gw-dlg nrv-no-ai';
    dlg.setAttribute('data-nrv-no-ai', '');
    dlg.setAttribute('aria-label', 'Gesetzliche Gewährleistung – Mitteilung der EU');
    dlg.innerHTML =
      '<div class="nrv-gw-dlg-bar">' +
        '<span>Gesetzliche Gewährleistung</span>' +
        '<button type="button" class="nrv-gw-dlg-x" data-gw-close aria-label="Schließen">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"></path></svg>' +
        '</button>' +
      '</div>' +
      '<div class="nrv-gw-dlg-scroll" tabindex="0">' +
        '<img class="nrv-gw-img" alt="" decoding="async">' +
      '</div>' +
      '<div class="nrv-gw-dlg-foot">' +
        '<a href="' + INFO_URL + '" target="_blank" rel="noopener">Mehr dazu auf „Ihr Europa“ (europa.eu)</a>' +
        '<span>Zum Vergrößern auf das Bild tippen</span>' +
      '</div>';
    document.body.appendChild(dlg);
    dlgImg = dlg.querySelector('img');

    dlg.addEventListener('click', function (e) {
      var t = e.target;
      if (t === dlg || (t.closest && t.closest('[data-gw-close]'))) { close(); return; }
      if (t === dlgImg) dlg.classList.toggle('is-zoom');
    });
    dlg.addEventListener('close', function () {
      document.documentElement.classList.remove('nrv-gw-lock');
      dlg.classList.remove('is-zoom');
      if (lastTrigger && lastTrigger.focus) { try { lastTrigger.focus(); } catch (err) {} }
      lastTrigger = null;
    });
  }

  function open(src, alt, trigger) {
    if (!dlg) build();
    lastTrigger = trigger || null;
    if (dlgImg.getAttribute('src') !== src) dlgImg.setAttribute('src', src);
    dlgImg.setAttribute('alt', alt || '');
    dlg.classList.remove('is-zoom');
    document.documentElement.classList.add('nrv-gw-lock');
    if (!dlg.open) dlg.showModal();
    var sc = dlg.querySelector('.nrv-gw-dlg-scroll');
    if (sc) { sc.scrollTop = 0; sc.scrollLeft = 0; }
  }

  function close() {
    if (dlg && dlg.open) dlg.close();
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented) return;
    if (e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var t = e.target && e.target.closest ? e.target.closest('[data-gw-open]') : null;
    if (!t) return;
    if (typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;
    var src = t.getAttribute('data-gw-full');
    if (!src) return;
    e.preventDefault();
    var inner = t.querySelector('img');
    open(src, t.getAttribute('data-gw-alt') || (inner && inner.getAttribute('alt')) || '', t);
  });

  /* ---------- 4) Nachladen ---------- */
  function hydrate(img) {
    var src = img.getAttribute('data-gw-src');
    if (!src) return;
    var set = img.getAttribute('data-gw-srcset');
    var sizes = img.getAttribute('data-gw-sizes');
    if (sizes) img.setAttribute('sizes', sizes);
    if (set) img.setAttribute('srcset', set);
    img.setAttribute('src', src);
    img.removeAttribute('data-gw-src');
    img.removeAttribute('data-gw-srcset');
    img.removeAttribute('data-gw-sizes');
  }

  var io = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          hydrate(en.target);
          io.unobserve(en.target);
        });
      }, { rootMargin: '200px 0px' })
    : null;

  function scan() {
    var list = document.querySelectorAll('img[data-gw-src]');
    for (var i = 0; i < list.length; i++) {
      if (!io) { hydrate(list[i]); continue; }
      if (!list[i].__gwObserved) { list[i].__gwObserved = true; io.observe(list[i]); }
    }
  }

  /* ---------- 2) Warenkorb-Drawer ---------- */
  function mountDrawer() {
    var tpl = document.getElementById('nrv-gw-tpl-drawer');
    var drawer = document.querySelector('.nrvh-cart-drawer');
    if (!tpl || !tpl.content || !drawer || drawer.__nrvGw) return;
    var body = drawer.querySelector('[data-cd-body]');
    var foot = drawer.querySelector('[data-cd-foot]');
    if (!body || !foot || !body.parentNode) return;
    drawer.__nrvGw = true;

    var scroller = document.createElement('div');
    scroller.className = 'nrvh-cd-scroll';
    body.parentNode.insertBefore(scroller, body);
    scroller.appendChild(body);

    var box = document.createElement('div');
    box.className = 'nrvh-cd-gw';
    box.hidden = true;
    box.appendChild(tpl.content.cloneNode(true));
    scroller.appendChild(box);

    var sync = function () {
      box.hidden = foot.hidden;
      if (!box.hidden) scan();
    };
    if ('MutationObserver' in window) {
      new MutationObserver(sync).observe(foot, { attributes: true, attributeFilter: ['hidden'] });
    }
    sync();
  }

  /* ---------- 3) Produktseite ---------- */
  function mountPdp() {
    var tpl = document.getElementById('nrv-gw-tpl-pdp');
    var main = document.querySelector('main[data-template^="product"]');
    if (!tpl || !tpl.content || !main) return;
    if (main.querySelector('.nrv-gw--pdp')) return;
    var anchor = main.querySelector('.text-block--text_delivery') ||
                 main.querySelector('.buy-buttons-block') ||
                 main.querySelector('product-form-component');
    if (!anchor || !anchor.parentNode) return;
    anchor.parentNode.insertBefore(tpl.content.cloneNode(true), anchor.nextSibling);
  }

  var pdpTimer;
  function watchPdp() {
    var main = document.querySelector('main[data-template^="product"]');
    if (!main || !document.getElementById('nrv-gw-tpl-pdp') || !('MutationObserver' in window)) return;
    new MutationObserver(function () {
      clearTimeout(pdpTimer);
      pdpTimer = setTimeout(mountPdp, 150);
    }).observe(main, { childList: true, subtree: true });
  }

  function boot() {
    mountDrawer();
    mountPdp();
    watchPdp();
    scan();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function () {
    mountDrawer();
    mountPdp();
    scan();
  });
})();
